
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/preferences",
      function () {
        return require("private-next-pages/account/preferences.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/preferences"])
      });
    }
  